/* eslint-disable */
<template>
  <div class="settings">
    <AdminNavigation ref="navigation" indexProps="10"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Forgot Password Log</h1></div>
        <div class="header-sub-title">Get the forgot password logs</div>
      </div>
    </div>
    <div class="panel">
      <AdminSettingsMenu indexProps="1-3"/>
      <div class="content">
        <div>
          <div class="tool-bar row">
            <div class="col">
              <div class="icon-group right-float-element">
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="Email Address"
                          v-model="listParam.EmailAddress"/>
                <el-input style="max-width: 150px" class="mr-1" @input="search()" clearable placeholder="Ip Address"
                          v-model="listParam.IpAddress"/>
                <el-select style="max-width: 180px" class="mr-1" @change="selectPage(1)" clearable placeholder="Action"
                           v-model="listParam.Action">
                  <el-option v-for="item in [ 'REQUEST', 'REQUEST_FAIL ', 'RESET_PASSWORD_SUCCESS', 'VERIFY_SUCCESS', 'NOTIFICATION_EMAIL_SUCCESS', 'NOTIFICATION_EMAIL_FAIL']" :key="item" :label="item" :value="item" />
                </el-select>
                <el-date-picker
                    style="width: 260px"
                    type="daterange"
                    v-model="dateValue"
                    start-placeholder="Start Date"
                    popper-class="date-range-picker-popper"
                    value-format="yyyy-MM-dd"
                    format="dd/MM/yyyy"
                    @change="changeDates"
                    end-placeholder="End Date"
                    clearable
                />
              </div>
            </div>
          </div>
          <div class="content-scroll-x">
            <div>
              <table class="table">
                <thead>
                <tr>
                  <th style="width:7%" class="long-text">ID</th>
                  <th style="width:20%" class="long-text">Email Address</th>
                  <th style="width:12%" class="long-text">IpAddress</th>
                  <th style="width:16%" class="long-text">Action</th>
                  <th style="width:17%; vertical-align:middle" class="icon-col">Log Date</th>
                  <th style="width:13%; vertical-align:middle" class="icon-col">SessionID</th>
                  <th style="width:15%; vertical-align:middle" class="icon-col">Reason</th>
                </tr>
                </thead>
              </table>
            </div>
            <!-- <div :class="specialists.length > 5 ? 'content-scroll-y' : ''"> -->
            <div class="content-scroll-y">
              <table class="table">
                <tbody>
                <tr v-for="(log, index) in logs" :key="index" >
                  <td style="width:7%" class="long-text">
                    {{ log.id }}
                  </td>
                  <td style="width:20%" class="long-text">
                    <el-tooltip effect="dark" :content="log.EmailAddress">
                      <span>{{ log.EmailAddress }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:12%" class="long-text">
                    {{ log.IpAddress }}
                  </td>
                  <td style="width:16%" class="long-text">
                    <el-tooltip effect="dark" :content="log.Action">
                      <span>{{ log.Action }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:17%;vertical-align:middle" class="icon-col">
                    {{ getTime(log.CreatedAt) }}
                  </td>
                  <td style="width:13%" class="long-text">
                    <el-tooltip effect="dark" :content="log.SessionID">
                      <span>{{ log.SessionID }}</span>
                    </el-tooltip>
                  </td>
                  <td style="width:15%" class="long-text">
                    <el-tooltip effect="dark" :content="log.Reason">
                      <span>{{ log.Reason }}</span>
                    </el-tooltip>
                  </td>
                </tr>
                <tr v-if="logs.length === 0">
                  <td colspan="9">No results to display.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSettingsMenu from '@/components/AdminSettingsMenu'
import { debounce } from 'lodash';
import Header from '@/components/Header'

export default {
  name: 'AdminErrorLog',
  components: {
    AdminNavigation,
    AdminSettingsMenu,
    Header,
  },
  data() {
    return {
      dateValue: [],
      hasError: false,
      logs: [],
      totalCount: 0,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        FileName: '',
        OperationType: '',
        UsernameLog: '',
        RH2Module: '',
        RH2ModuleID: '',
        LogDateFrom: null,
        LogDateTo: null
      },
      successMessage: '',
    }
  },
  computed: {},
  methods: {
    search: debounce(function () {
      this.selectPage(1)
    }, 800),
    changeDates(v) {
      if (v) {
        this.listParam.StartTime  = v[0]
        this.listParam.EndTime = v[1]
      } else {
        this.listParam.StartTime  = null
        this.listParam.EndTime = null
      }
      this.selectPage(1)
    },
    getTime(item) {
      return moment(item).format('DD/MM/YYYY HH:mm:ss')
    },
    sortParam(v) {
      this.listParam.SortFlag = v
      this.selectPage(1)
    },
    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },
    async loadData() {
      this.$store.dispatch("loading/setLoadComponent", true)
      let param = {}
      for (let i in this.listParam) {
        if (this.listParam[i] !== undefined && this.listParam[i] !== null && this.listParam[i] !== "") param[i] = this.listParam[i]
      }
      const {data, count} = await utilities.getForgotPasswordLogs(param)
      this.logs = data
      this.totalCount = count
      this.$store.dispatch("loading/setLoadComponent", false)
    },

    addNewPersonCondition() {
      this.$refs.addPersonConditionModal.isEdit = false
      this.$refs.addPersonConditionModal.handleModal()
    },

    editCondition(index) {
      var item = this.personConditions[index]
      this.$refs.addPersonConditionModal.isEdit = true
      this.$refs.addPersonConditionModal.editItem(item)
      this.$refs.addPersonConditionModal.handleModal()

    }
  },
  async beforeMount() {
    await this.loadData()
  },
  mounted() {
  },
}
</script>
